import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import { application } from '../application'

import CheckProducts from '../front_stage/check_products_controller'
import ConsultantFormValid from '../front_stage/consultant_form_valid_controller'
import DetailsWithModal from '../front_stage/details_with_modal_controller'
import FromUnsavedConfirm from '../front_stage/form_unsaved_confirm_controller'
import ScrollHint from '../front_stage/scroll_hint_controller'
import SetConversionCookies from '../front_stage/set_conversion_cookies_controller'
import StructuredDataFaq from '../front_stage/structured_data_faq_controller'
import TransformHalfFont from '../front_stage/transform_half_font_controller'
import RemoveHyphen from '../front_stage/remove_hyphen_controller'
import NormalizeTel from '../front_stage/normalize_tel_controller'

application.register('check-products', CheckProducts)
application.register('consultant-form-valid', ConsultantFormValid)
application.register('details-with-modal', DetailsWithModal)
application.register('form-unsaved-confirm', FromUnsavedConfirm)
application.register('scroll-hint', ScrollHint)
application.register('set-conversion-cookies', SetConversionCookies)
application.register('structured-data-faq', StructuredDataFaq)
application.register('transform-half-font', TransformHalfFont)
application.register('remove-hyphen', RemoveHyphen)
application.register('normalize-tel', NormalizeTel)

const context = require.context('.', true, /_controller\.js$/)
application.load(definitionsFromContext(context))
